import { Box, Stack, Button, Typography, List, ListItem, ListItemIcon, ListItemText, Rating } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import LogoutIcon from '@mui/icons-material/Logout';
import OutlinedFlagRoundedIcon from '@mui/icons-material/OutlinedFlagRounded';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import Timer from '../Timer';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
// import { isMobileOnly, isMobile, isTablet, isDesktop } from 'react-device-detect';


export default function SinglePlayerSideBarRight({onExport, gameState, onExit, color, setExitConfirmation, setResignConfirmation, botLevel, time, setTime, turn, inverse}) {

    return (

    <Box
        sx={{
          width: 380,
          borderRadius: 7,
          flexShrink: 0,
          backgroundColor: '#36454F',
          opacity: [1, 0.2, 1],
          display: {
            xs: 'none',
            md: 'block',
          },
          top: { md: 96 },
          position: { md: 'sticky' },
        }}
      >
            <Typography sx={{ mt: 7, mb: 2, ml:4 }} variant="h4" align='left' component="div">
                Room Detail
            </Typography>

            <List dense={false} sx={{alignItems:'center'}}>
                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <SmartToyIcon sx={{fontSize: '42px'}}/>
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{fontSize: '32px'}}
                    secondaryTypographyProps={{fontSize: '24px'}}
                    primary="Bot Level: "
                    secondary={ <Rating
                                name="botLevel"
                                value={botLevel}
                                readOnly={true}
                                />
                              }
                  />
                </ListItem>
                <ListItem sx={{width: 'auto', mx: 2}}>
                  <ListItemIcon sx={{ mr: 2}}>
                    <HourglassEmptyOutlinedIcon sx={{fontSize: '42px', color: '#8B8000', backgroundColor: color, borderRadius: 2}}/>
                  </ListItemIcon>

                  <ListItemText
                    primaryTypographyProps={{fontSize: '32px'}}
                    secondaryTypographyProps={{fontSize: '24px', color: 'black'}}
                    primary="Your time "
                    secondary={<Timer minSecs={time} setTime={setTime} isRunning={turn && gameState === 'start'} inverse={inverse}/>}
                  />
                  
                </ListItem>


            </List>




          <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="20vh"
            >
            <Stack direction='column' spacing='2em'> 
                <Button className='btn3' onClick={() => setResignConfirmation(true)} endIcon={<OutlinedFlagRoundedIcon/>}> Resign </Button>
                {gameState === 'afterGame' ? <Button className='btn3' onClick={onExport} endIcon={<ShareIcon/>}> Export Your Game </Button>  : <></>}
                {gameState === 'afterGame' ? <Button className='btn3' onClick={onExit} endIcon={<LogoutIcon/>}> Play Another Game </Button>  : <></>}
            </Stack>

            </Box>



    </Box>
    
    )



}